<template>
  <div class="sidebar">
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
             text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                  {{ threeItem.title }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                {{ subItem.title }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
  import bus from './bus';
  export default {
    name: 'AlarmPointSidebar',
    data() {
      return {
        collapse: false,
        items: [
          {
            icon: 'el-icon-video-camera',
            index: 'monitor',
            title: '实时监控',
            subs:[
              {
                index: 'monitor',
                title: '室内',
              },
              {
                index: 'monitor-outdoor',
                title: '室外',
              },
            ]
          },
          {
            icon: 'el-icon-video-camera-solid',
            index: 'videoPlayBack',
            title: '录像回放',
            subs:[
              {
                index: 'videoPlayBack',
                title: '室内',
              },
              {
                index: 'videoPlayBack-outdoor',
                title: '室外',
              },
            ]
          },
          // {
          //   icon: 'el-icon-s-flag',
          //   index: 'alarmPointView',
          //   title: '警报点节点信息'
          // },
          // {
          //   icon: 'el-icon-s-order',
          //   index: 'alarmControllerView',
          //   title: '警报点控制器信息'
          // },
          // {
          //   icon: 'el-icon-bell',
          //   index: 'alarmView',
          //   title: '警报器信息'
          // },
          {
            icon: 'el-icon-s-flag',
            index: 'alarmPointTotalInfo',
            title: '警报点信息'
          },
          {
            icon: 'el-icon-s-platform',
            index: 'iotterminal',
            title: '物联网监测终端信息'
          },
          {
            icon: 'el-icon-s-data',
            index:'3',
            title: '动态数据',
            subs: [
              {
                index: 'realTimeData',
                title: '实时数据',
              },
              {
                index: 'historyData',
                title: '历史数据',
              },
            ]
          },
          {
            icon: 'el-icon-collection',
            index: '4',
            title: '历史记录查询',
            subs: [
              {
                index: 'staticInformationRecordList',
                title: '静态信息修改记录',
              },
              {
                index: 'alarmInspectRecord',
                title: '巡检记录',
              },
              {
                index: 'alarmReportRecord',
                title: '报修记录'
              },
              {
                index: 'alarmRepairRecord',
                title: '维修记录'
              },
              {
                index: 'alarmUpdateRecord',
                title: '升级记录'
              },
              {
                index: 'alartRecord',
                title: '告警记录'
              }
            ]
          },
          {
            icon: 'el-icon-picture-outline',
            index: 'qrcode',
            title: '二维码'
          },
          {
            icon: 'el-icon-cpu',
            index: 'hardwareInfo',
            title: '硬件信息'
          },
        ],
      }
    },
    computed:{
      // onRoutes(){
      //   return this.$route.path.replace('/','');
      // }
    },
    created(){
      // 通过 Event Bus 进行组件间通信，来折叠侧边栏
      bus.$on('collapse', msg => {
        this.collapse = msg;
      })
    }
  }
</script>

<style scoped>
  .sidebar{
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom:0;
    overflow-y: scroll;
  }
  .sidebar::-webkit-scrollbar{
    width: 0;
  }
  .sidebar-el-menu:not(.el-menu--collapse){
    width: 250px;
  }
  .sidebar > ul {
    height:100%;
  }
</style>
